import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import StandardModal from 'components/consumer/StandardModal';
import avo from 'analytics/avo';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import ArrowDownSimple from 'components/icons/iconArrowDownSimple';
import { colorBrand } from 'styles/layout/colors';
const formatDistance = distanceInMiles => {
  if (!distanceInMiles && distanceInMiles !== 0) return '';
  return distanceInMiles < 1 ? `${Math.round(distanceInMiles * 10) / 10} mi` : `${Math.round(distanceInMiles)} mi`;
};
const formatStoreHours = hoursString => {
  if (!hoursString) return [];
  return hoursString.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
};
const handleBrowseProducts = store => {
  const {
    storeData
  } = store;
  const showroomUrl = storeData?.rs_store_landing_page || '';
  avo.ctaClicked({
    text: storeData?.name,
    targetUrl: showroomUrl,
    cta: 'Retail Store',
    location: 'Category Page'
  });
  window.open(showroomUrl, '_blank');
};
const ProductCardMultipleStoresModal = t0 => {
  const $ = _c(17);
  const {
    stores: t1,
    isOpen,
    onClose
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const stores = t2;
  const [expandedStoreIndex, setExpandedStoreIndex] = useState(0);
  let t3;
  if ($[2] !== expandedStoreIndex) {
    t3 = index => {
      if (expandedStoreIndex !== index) {
        setExpandedStoreIndex(index);
      }
    };
    $[2] = expandedStoreIndex;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleStore = t3;
  if (!stores || stores.length === 0) {
    return null;
  }
  let t4;
  if ($[4] !== expandedStoreIndex || $[5] !== stores || $[6] !== toggleStore) {
    let t5;
    if ($[8] !== expandedStoreIndex || $[9] !== toggleStore) {
      t5 = (store, index_0) => {
        const {
          storeData,
          distance
        } = store;
        const isExpanded = expandedStoreIndex === index_0;
        const isFirst = index_0 === 0;
        const distanceText = formatDistance(distance);
        const storeHours = formatStoreHours(storeData?.open_hours);
        const storeLocationUrl = storeData?.google_map || "";
        const storeLocation = `${storeData?.street}, ${storeData?.city}, ${storeData?.state} ${storeData?.zip}`;
        const storeCalendly = storeData?.calendaly || "";
        const storeShowroomUrl = storeData?.rs_store_landing_page || "";
        return <div key={storeData?.id || index_0} className={isFirst ? "" : "border-t border-gray-light6 pt-4 mt-8"}><button type="button" className="w-full flex items-center justify-between cursor-pointer bg-transparent border-0 p-0 text-left mb-2" onClick={() => toggleStore(index_0)} aria-expanded={isExpanded} aria-label={`Toggle ${storeData?.name} details`}><div className="flex items-center gap-2"><h3 className="text-base font-bold text-brand m-0">{storeData?.name} Showroom</h3>{distanceText && <span className="text-sm text-gray-light2">({distanceText})</span>}</div><ArrowDownSimple color={colorBrand} className={`transition-transform duration-300 ease-in-out ${isExpanded ? "rotate-180" : ""}`} /></button><div className={`transition-opacity duration-300 ease-in-out ${isExpanded ? "opacity-100" : "opacity-0 h-0 overflow-hidden"}`}><div className="flex flex-col md:flex-row items-start mt-8"><div className="flex flex-col items-start"><h4 className="text-lg font-bold mb-4">Store Hours</h4>{storeHours.length > 0 ? storeHours.map(_temp) : <p className="text-xs font-bold text-gray-light2 tracking-wide">Hours not available</p>}</div><div className="flex flex-col items-start md:pl-8 pt-8 md:pt-0"><h4 className="text-lg font-bold mb-4">Location</h4><a className="text-sm text-brand font-bold no-underline" href={storeLocationUrl} target="_blank" rel="noreferrer">{storeLocation}</a>{storeCalendly && <CtaLink size="base" color="brand" styling="solid-button" to={storeCalendly} className="my-6">Book a Virtual Appointment</CtaLink>}{storeShowroomUrl && <button type="button" className="text-sm text-brand font-bold no-underline" onClick={() => handleBrowseProducts(store)} aria-label="Browse products in Showroom">Browse products on display here</button>}</div></div></div></div>;
      };
      $[8] = expandedStoreIndex;
      $[9] = toggleStore;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = stores.map(t5);
    $[4] = expandedStoreIndex;
    $[5] = stores;
    $[6] = toggleStore;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div>{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isOpen || $[14] !== onClose || $[15] !== t5) {
    t6 = <StandardModal className="ProductCardMultipleStoresModal" isOpen={isOpen} theme="light" onClose={onClose}>{t5}</StandardModal>;
    $[13] = isOpen;
    $[14] = onClose;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
ProductCardMultipleStoresModal.propTypes = {
  isOpen: PropTypes.bool,
  stores: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func
};
export default withBrowserOnly(ProductCardMultipleStoresModal);
function _temp(hourData) {
  return <p className="text-xs font-bold text-gray-light2 whitespace-nowrap leading-normal tracking-wide" key={hourData}>{hourData}</p>;
}